export default __webpack_public_path__ + "static/media/linkdin.85e2ef09.svg";